var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphoneSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.27936 5.37334C5.13032 5.32987 4.97321 5.3217 4.82047 5.34947C4.66773 5.37724 4.52356 5.4402 4.39936 5.53334C4.27516 5.62649 4.17436 5.74727 4.10493 5.88613C4.0355 6.02499 3.99936 6.1781 3.99936 6.33334V23.6667C3.99936 23.8219 4.0355 23.975 4.10493 24.1139C4.17436 24.2527 4.27516 24.3735 4.39936 24.4667C4.52356 24.5598 4.66773 24.6228 4.82047 24.6505C4.97321 24.6783 5.13032 24.6701 5.27936 24.6267L17.0001 21.2081V8.79188L5.27936 5.37334Z",
    fill: "#564FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99936 6.33334V23.6667C3.99936 23.8219 4.0355 23.975 4.10493 24.1139C4.17436 24.2527 4.27516 24.3735 4.39936 24.4667C4.52356 24.5598 4.66773 24.6228 4.82047 24.6505C4.97321 24.6783 5.13032 24.6701 5.27936 24.6267L27.2794 18.21C27.4871 18.1494 27.6695 18.0231 27.7994 17.85C27.9292 17.6769 27.9994 17.4664 27.9994 17.25V12.75C27.9994 12.5336 27.9292 12.3231 27.7994 12.15C27.6695 11.9769 27.4871 11.8506 27.2794 11.79L5.27936 5.37334C5.13032 5.32987 4.97321 5.3217 4.82047 5.34947C4.66773 5.37724 4.52356 5.4402 4.39936 5.53334C4.27516 5.62649 4.17436 5.74727 4.10493 5.88613C4.0355 6.02499 3.99936 6.1781 3.99936 6.33334V6.33334Z",
    stroke: "#564FFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.4581V24C23 24.2652 22.8946 24.5196 22.7071 24.7071C22.5196 24.8946 22.2652 25 22 25H18C17.7348 25 17.4804 24.8946 17.2929 24.7071C17.1054 24.5196 17 24.2652 17 24V8.79187",
    stroke: "#564FFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneSimple);
export default __webpack_public_path__ + "static/media/MegaphoneSimple.f3442d80fe405d2479355d810852607d.svg";
export { ForwardRef as ReactComponent };